// Copyright (c) 2019 Deere & Company

import actions from '../../action-list';
import {findMatchingKey} from '../../shared/services/claim-shared-helper';

export const addPart = () => ({
    type: actions.CREATE_CLAIM_WEAR_PARTS_PART
});

export const deletePart = index => ({
    index,
    type: actions.DELETE_CLAIM_WEAR_PARTS_PART
});

export const changePartProperty = (index, data, property) => ({
    data,
    index,
    property,
    type: actions.UPDATE_CLAIM_WEAR_PARTS_PART_FIELDS
});

export const changePartsUnit = (index, unit, unitCollection) => ({
    data: findMatchingKey(unit, unitCollection),
    index,
    type: actions.UPDATE_CLAIM_WEAR_PARTS_PART_UNIT
});



// WEBPACK FOOTER //
// ./src/claim/wear-parts/action-creators/parts.js